import React from 'react';
import { useTranslation } from 'react-i18next';
import { closeDialog } from '../../../../store/actionCreators/dialog';
import { getAccountAvatars } from "../../../../store/selectors";
import { useDispatch, useSelector } from 'react-redux';
import { requestJoinClub } from "../../../../store/actionCreators/club";
import Avatar from '../../../Units/Avatar';

const ClubConfirmation =({ clubDetails }) => {
  const { t } = useTranslation();
    const dispatch = useDispatch();
    const avatarList = useSelector(getAccountAvatars);
    console.log(avatarList);

    const joinClub = () => {
        dispatch(requestJoinClub(clubDetails));
    }
    return (
        <React.Fragment>
            <div className={`clubavatar`}>
                <Avatar data={avatarList[clubDetails.clubId]} />
            </div>
            <div className = {`unionInfo`}>
                {clubDetails.clubId && <span>{t('clubId')}: {clubDetails.clubId}</span>}
                {clubDetails.agentId && <p>{t('agentId')}: {clubDetails.agentId}</p>}
            </div>
            <div className={`dialogConfirmBox`}>
                <button className="primary" onClick={()=>joinClub()}>{t('button.apply')}</button>
            </div>
        </React.Fragment>
    );
};

export default ClubConfirmation;
